// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__wdMlT","amount":"Amount_amount__16QVa","tip":"Amount_tip__hj_KA","tipHeader":"Amount_tipHeader__29AMc","tipsWrap":"Amount_tipsWrap__24eqn"};